import MobileDrawer from '@c/drawers/MobileDrawer';
import { Bike } from 'models/shared';
import { UserDocument } from 'models/user';
import EditGarageForm from './forms/EditGarageForm';

type MobileEditGarageModalProps = {
  open: boolean;
  dismiss: () => void;
  userDoc: UserDocument;
  onAddBikeClick: () => void;
  onSyncSelectedBikes: (bikes: Bike[]) => void;
  previousSelectedBikes: Bike[];
};

export default function MobileEditGarageModal({
  open,
  dismiss,
  userDoc,
  onAddBikeClick,
  onSyncSelectedBikes,
  previousSelectedBikes,
}: MobileEditGarageModalProps) {
  return (
    <MobileDrawer show={open} dismiss={dismiss} title="My Garage">
      <EditGarageForm
        bikes={userDoc.bikes ?? []}
        onAddBikeClick={onAddBikeClick}
        onSyncSelectedBikes={(bikes) => {
          onSyncSelectedBikes(bikes);
          dismiss();
        }}
        previousSelectedBikes={previousSelectedBikes}
      />
    </MobileDrawer>
  );
}
